export const SCENE_ID = 'minihra-asociace'
export const BUBBLE_DISPLAY_MS = 5000
export const WRONG_BUBBLE_COUNT = 3

export interface AsociaceItem {
  id: string
  correct: boolean
  position: { x: number; y: number }
  width: number
  /** Width of the speech bubble in % of the items container. Defaults to item width. */
  bubbleWidth?: number
  /** How long the bubble stays visible in ms. Defaults to BUBBLE_DISPLAY_MS (5000). */
  bubbleDuration?: number
}

export interface AsociaceStage {
  id: string
  /** CSS aspect-ratio (width / height). Keeps item positions consistent across screen sizes. */
  aspectRatio: number
  backgroundColor: string
  items: AsociaceItem[]
}

export const STAGES: AsociaceStage[] = [
  {
    id: 'stage-1',
    aspectRatio: 1.43,
    backgroundColor: '#167c55',
    items: [
      { id: 'mrkev', correct: true, position: { x: 46, y: 0 }, width: 28, bubbleWidth: 45 },
      { id: 'jablko', correct: false, position: { x: 13, y: 21 }, width: 25 },
      { id: 'tresen', correct: false, position: { x: 64, y: 48 }, width: 24 },
      { id: 'jahoda', correct: false, position: { x: 30, y: 63 }, width: 20 },
    ],
  },
  {
    id: 'stage-2',
    aspectRatio: 1.11,
    backgroundColor: '#167c55',
    items: [
      { id: 'kruhy', correct: false, position: { x: 15, y: 0 }, width: 22 },
      { id: 'cinky', correct: false, position: { x: 55, y: 2 }, width: 28 },
      { id: 'mic', correct: false, position: { x: 39, y: 25 }, width: 26 },
      { id: 'svihadlo', correct: false, position: { x: 14, y: 52 }, width: 27 },
      { id: 'raketa', correct: false, position: { x: 61, y: 58 }, width: 24 },
      { id: 'lopatka', correct: true, position: { x: 27, y: 80 }, width: 26, bubbleWidth: 45 },
    ],
  },
  {
    id: 'stage-3',
    aspectRatio: 1.0,
    backgroundColor: '#167c55',
    items: [
      { id: 'cepice', correct: false, position: { x: 18, y: 3 }, width: 25 },
      { id: 'rukavice', correct: false, position: { x: 61, y: 0 }, width: 27 },
      { id: 'sandaly', correct: true, position: { x: 16, y: 39 }, width: 25, bubbleWidth: 45 },
      { id: 'sala', correct: false, position: { x: 65, y: 35 }, width: 25 },
      { id: 'svetr', correct: false, position: { x: 17, y: 81 }, width: 27 },
      { id: 'trenyrky', correct: true, position: { x: 61, y: 79 }, width: 26, bubbleWidth: 45 },
    ],
  },
  {
    id: 'stage-4',
    aspectRatio: 0.71,
    backgroundColor: '#167c55',
    items: [
      { id: 'zapalky', correct: false, position: { x: 47, y: 0 }, width: 25 },
      { id: 'nuz', correct: false, position: { x: 13, y: 7 }, width: 27 },
      { id: 'sekyra', correct: false, position: { x: 36, y: 30 }, width: 27 },
      { id: 'vysavac', correct: true, position: { x: 65, y: 26 }, width: 27, bubbleWidth: 45 },
      { id: 'bota', correct: true, position: { x: 7, y: 42 }, width: 29, bubbleWidth: 45 },
      { id: 'batoh', correct: false, position: { x: 39, y: 58 }, width: 25 },
      { id: 'klavir', correct: true, position: { x: 68, y: 52 }, width: 24, bubbleWidth: 45 },
      { id: 'cutora', correct: false, position: { x: 9, y: 70 }, width: 24 },
      { id: 'esus', correct: false, position: { x: 65, y: 75 }, width: 24 },
    ],
  },
]
